import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M10 16v-8","key":"svg-0"}],["path",{"d":"M14 8v8","key":"svg-1"}],["path",{"d":"M10 12h4","key":"svg-2"}]]

const IconSignalH = createReactComponent('outline', 'signal-h', 'SignalH', __iconNode);

export default IconSignalH;